export default {
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
  goToConversationAriaLabel: {
    id: 'bo_sellers_customer_care_table_column_go_to_conversation_aria_label',
    defaultMessage: 'Go to the conversation',
  },
  uploadReceiptButtonLabel: {
    id: 'bo_sellers_customer_care_upload_receipt_button_label',
    defaultMessage: 'Upload receipt',
  },
  uploadSuccessToastLabel: {
    id: 'bo_sellers_customer_care_upload_receipt_success_toast',
    defaultMessage:
      'The receipt for order #{orderId} is uploaded and being confirmed.',
  },
  uploadConfirmationErrorToastLabel: {
    id: 'bo_sellers_customer_care_upload_receipt_fail_toast',
    defaultMessage:
      'Receipt confirmation failed for order #{orderId}.  Please try again.',
  },
  uploadFailedErrorMessage: {
    id: 'bo_sellers_customer_care_previous_upload_receipt_fail_error_message',
    defaultMessage: 'Previous upload failed',
  },
}
